import React from 'react';
import { Tooltip, Tooltiptext } from '@flexisaf/flexibull2';
import { darken } from 'polished';
import styled, { css } from 'styled-components';
import Theme from 'utils/theme';
import PropTypes from 'prop-types';

const SideModalWrapper = styled.div`
  width: 100%;
  max-width: ${(props) => props.fullScreen ? '100vw' : '1000px' };
  top: 0;
  right: 0;
  position: fixed;
  background: #fff;
  height: 100vh;
  z-index: 1000;
  box-shadow: -5px 0 35px rgba(0, 0, 0, 0.2);
  border-left: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
  transform: translate3d(calc(100% + 72px), 0, 0);
  visibility: hidden;
  pointer-events: none;
  will-change: transform;
  transition:
    transform 0.38s cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0s linear 0.38s;

  ${(props) =>
    props.open &&
    css`
      transform: translate3d(0, 0, 0);
      visibility: visible;
      pointer-events: auto;
      transition:
        transform 0.42s cubic-bezier(0.22, 1, 0.36, 1),
        visibility 0s linear 0s;
    `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  & .side-container {
    width: inherit;
    height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: max-content max-content auto;
    overflow-y: auto;

    & .applicant-info {
      background: #f6f5fb;
      grid-row: 1;
      grid-column: 1 / 4;
      padding: 22px 24px 8px;
      position: sticky;
      z-index: 3;
      top: 0;

      display: grid;
      grid-template-columns: minmax(0, 1fr) max-content;
      align-items: center;
      grid-gap: 16px 24px;

      & .applicant-info-actions {
        grid-row: 1;
        grid-column: 2;
        align-self: start;
        &.flex-div {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          gap: 8px;
          & > * {
            margin: 0;
            flex: 0 0 auto;
          }
        }
      }
      & .applicant-info-details {
        grid-row: 1;
        grid-column: 1;
      }

      @media (max-width: 1000px) {
        grid-template-columns: minmax(0, 1fr);
        padding: 16px 16px 12px;
        padding-right: 56px;
        align-items: stretch;

        & .applicant-info-details {
          grid-row: 1;
          grid-column: 1;
        }

        & .applicant-info-actions {
          grid-row: 2;
          grid-column: 1;
          width: 100%;
          padding-right: 0;

          &.flex-div {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: stretch;
            width: 100%;
            gap: 8px;
          }

          & .applicant-primary-actions,
          & .flexi-dropdown-trigger,
          & .flexi-button {
            width: 100%;
            max-width: 100%;
          }

          & .flexi-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.45rem;
            padding-left: 1rem;
            padding-right: 1rem;
            box-sizing: border-box;

            & .flexi-button-icon-left,
            & .flexi-button-icon-right {
              width: auto;
              height: auto;
              min-width: 0;
              flex: 0 0 auto;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 1;

              & i {
                display: inline-flex;
                align-items: center;
                line-height: 1;
              }
            }

            & .flexi-button-center {
              flex: 0 0 auto;
              flex-grow: 0;
              width: auto;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 1;
            }
          }

          & .applicant-primary-actions {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin: 0 !important;
          }
        }
      }
    }
    & .applicant-info-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .applicant-detail {
      background: #f6f5fb;
      min-height: 0;
      grid-row: 2;
      grid-column: 1 / 4;
      padding: 4px 24px 22px;
      display: grid;
      grid-template-columns: minmax(0, 1fr) max-content;
      align-items: center;
      grid-gap: 16px 24px;

      & .applicant-detail-info {
        grid-row: 1;
        grid-column: 1;
        & > div {
          margin-bottom: 8px;
        }
        & .flexi-tag {
          margin: 4px;
        }
      }
      & .applicant-detail-photo {
        grid-row: 1;
        grid-column: 2;
        align-self: end;
        & .applicant-detail-photo-container {
          display: inline-block;
          padding: 0;
          border: 3px solid #fff;
          border-radius: 16px;
          background: #fff;
          box-shadow: 0 12px 28px rgba(61, 43, 86, 0.14);
          overflow: hidden;
          & img {
            display: block;
            width: 128px;
            height: 160px;
            object-fit: cover;
            border-radius: 0;
          }
        }
      }
    }
    & .application-detail-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .application-detail {
      background: #f7f8fa;
      grid-row: 3;
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }

    & .show-on-mini {
      display: none;
    }
  }

  & .sideControl {
    position: absolute;
    right: 100%;
    padding: 8px;
    border: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
    background: #fff;
    border-top: none;
    border-right: 0;
    box-shadow: -5px 0 35px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 0 ${(props) => props.theme.SecondaryRadius};
    z-index: 5;

    @media (max-width: 1000px) {
      top: 0;
      right: 0;
      display: flex;

      & .applicant-resizer {
        display: none;
      }
    }
  }
  @media (min-width: 1000px) {
    ${(props) =>
      props.maximized &&
      css`
        max-width: calc(100vw - 10px - ${Theme.SideNavOpen});

        & .side-container {
          grid-template-columns: minmax(0, 340px) minmax(0, 1fr);
          grid-template-rows: max-content auto;
          overflow: hidden;
          background: ${(props) => props.theme.PrimaryFade};

          & .applicant-info {
            grid-column: 1;
            grid-row: 1;
            position: relative;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
            min-width: 0;
            overflow: visible;

            & .applicant-info-details {
              min-width: 0;
            }

            & .applicant-info-actions {
              width: 100%;
              min-width: 0;

              &.flex-div {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 8px;

                & > * {
                  display: flex !important;
                  flex-direction: column;
                  align-items: stretch;
                  gap: 8px;
                  width: 100% !important;
                  min-width: 0;
                  max-width: 100%;
                  margin: 0 !important;
                  text-align: left;
                }

                & > * > div,
                .flexi-dropdown-trigger {
                  display: block !important;
                  width: 100% !important;
                }

                .flexi-button {
                  display: flex !important;
                  align-items: center;
                  justify-content: center;
                  width: 100% !important;
                  max-width: 100%;
                  height: 42px !important;
                  box-sizing: border-box;
                }
              }
            }
          }
          & .applicant-info-loader {
            grid-column: 1;
            grid-row: 1 /4;
            grid-template-columns: max-content;
            position: relative;
            background: #fff;
            align-items: stretch;
          }
          & .applicant-detail {
            grid-column: 1;
            grid-row: 2 / 3;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: max-content auto;
            padding-top: 0;

            & .applicant-detail-info {
              grid-row: 2;
              grid-column: 1;
            }
            & .applicant-detail-photo {
              grid-row: 1;
              grid-column: 1;

              & .applicant-detail-photo-container {
                & img {
                  width: 120px;
                  height: 150px;
                }
              }
            }
          }
          & .application-detail {
            grid-column: 2;
            grid-row: 1 / 4;
            height: 100vh;
            min-width: 0;
            overflow-y: auto;
            background: #f7f8fa;
            container-type: inline-size;

            .form-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }

            @container (max-width: 520px) {
              .form-grid {
                grid-template-columns: minmax(0, 1fr) !important;
              }
            }
          }

          & .show-on-mini {
            display: block;
          }
        }
      `}
  }
  & .applicant-info,
  & .applicant-detail {
    background: #f6f5fb;
  }

  & .applicant-detail {
    min-height: 0;
    padding-top: 0;
  }

  & .profile-identity .profile-name {
    letter-spacing: -0.02em;
    color: ${(props) => props.theme.PrimaryDark};
  }

  & .profile-number {
    color: ${(props) => props.theme.PrimaryGrey};
    font-size: 13px;
  }

  & .profile-facts {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 22px;
    margin-top: 16px;
  }

  & .profile-fact {
    min-width: 0;
    max-width: 100%;
  }

  & .profile-fact-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${(props) => props.theme.PrimaryGrey};
  }

  & .profile-fact-value {
    display: block;
    margin-top: 3px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;
    color: ${(props) => props.theme.PrimaryDark};

    a {
      color: ${(props) => props.theme.PrimaryColor};
      text-decoration: none;
    }
  }

  & .view-applicant-box {
    .flexi-tab-header {
      margin: 0 0 18px;
      gap: 4px;
      border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
      overflow-x: auto;
      flex-wrap: nowrap;
    }

    .flexi-tab-header-box {
      min-height: 48px;
      padding: 0 18px;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: -0.01em;
      color: ${(props) => props.theme.PrimaryDark};

      i {
        font-size: 16px;
      }

      &.flexi-tab-inactive {
        color: ${(props) => props.theme.PrimaryGrey};
        opacity: 1;
      }

      &.flexi-tab-label-active {
        color: ${(props) => props.theme.PrimaryColor};
        font-weight: 700;

        &::after {
          height: 3px;
          background: ${(props) => props.theme.PrimaryColor};
        }
      }
    }
  }

  & .applicant-infox {
    max-width: 960px;
    border: none;
    background: transparent;
    margin: 4px 0 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;

    & .applicant-infox-row {
      padding: 18px 18px 16px;
      background: #fff;
      border: 1px solid #eceaf3;
      border-radius: 16px;
      box-shadow: 0 8px 24px rgba(61, 43, 86, 0.04);
      display: flex;
      flex-direction: column;
      gap: 10px;

      & .applicant-infox-row-header {
        margin: 0 0 4px;
        padding: 0 0 0 12px;
        border: none;
        border-left: 3px solid ${(props) => props.theme.PrimaryColor};
        font-size: 13px !important;
        letter-spacing: 0.08em;
        color: ${(props) => props.theme.PrimaryDark};
      }

      & .form-grid {
        margin: 0;
        width: 100%;
        align-items: stretch !important;
        grid-gap: 10px !important;
        row-gap: 10px !important;
        column-gap: 10px !important;
      }

      & .single-form {
        height: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin: 0;
        padding: 12px 14px;
        border: none;
        border-radius: 12px;
        background: #f6f5fb;
      }

      & .profile-field-label {
        font-size: 10px !important;
        font-weight: 600 !important;
        letter-spacing: 0.08em;
        line-height: 1.35;
        overflow-wrap: break-word;
        color: #8a849b !important;
      }

      & .profile-field-value,
      & .profile-field-value p {
        margin: 6px 0 0;
        font-size: 15px !important;
        line-height: 1.4;
        color: ${(props) => props.theme.PrimaryDark};
        font-weight: 600;
        white-space: normal !important;
        overflow-wrap: anywhere;
      }

      & .profile-field-value.is-empty,
      & .profile-field-value.is-empty p {
        color: #b7b3c2;
        font-weight: 500;
      }
    }
  }
`;

const FullScreenSideModalWrapper = styled.div`
  width: 100%;
  max-width: 100vw;
  top: 0;
  right: 0;
  position: fixed;
  background: #fff;
  height: 100vh;
  z-index: 1000;
  box-shadow: -5px 0 35px rgba(0, 0, 0, 0.2);
  border-left: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
  display: block;

  & .side-container {
    width: inherit;
    height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: max-content max-content auto;
    overflow-y: auto;

    & .applicant-info {
      background: #f6f5fb;
      grid-row: 1;
      grid-column: 1 / 4;
      padding: 22px 24px 8px;
      position: sticky;
      z-index: 3;
      top: 0;

      display: grid;
      grid-template-columns: minmax(0, 1fr) max-content;
      align-items: center;
      grid-gap: 16px 24px;

      & .applicant-info-actions {
        grid-row: 1;
        grid-column: 2;
        align-self: start;
        &.flex-div {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          gap: 8px;
          & > * {
            margin: 0;
            flex: 0 0 auto;
          }
        }
      }
      & .applicant-info-details {
        grid-row: 1;
        grid-column: 1;
      }

      @media (max-width: 1000px) {
        grid-template-columns: minmax(0, 1fr);
        padding: 16px 16px 12px;
        padding-right: 56px;
        align-items: stretch;

        & .applicant-info-details {
          grid-row: 1;
          grid-column: 1;
        }

        & .applicant-info-actions {
          grid-row: 2;
          grid-column: 1;
          width: 100%;
          padding-right: 0;

          &.flex-div {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: stretch;
            width: 100%;
            gap: 8px;
          }

          & .applicant-primary-actions,
          & .flexi-dropdown-trigger,
          & .flexi-button {
            width: 100%;
            max-width: 100%;
          }

          & .flexi-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.45rem;
            padding-left: 1rem;
            padding-right: 1rem;
            box-sizing: border-box;

            & .flexi-button-icon-left,
            & .flexi-button-icon-right {
              width: auto;
              height: auto;
              min-width: 0;
              flex: 0 0 auto;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 1;

              & i {
                display: inline-flex;
                align-items: center;
                line-height: 1;
              }
            }

            & .flexi-button-center {
              flex: 0 0 auto;
              flex-grow: 0;
              width: auto;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 1;
            }
          }

          & .applicant-primary-actions {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin: 0 !important;
          }
        }
      }
    }
    & .applicant-info-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .applicant-detail {
      background: #f6f5fb;
      min-height: 0;
      grid-row: 2;
      grid-column: 1 / 4;
      padding: 4px 24px 22px;
      display: grid;
      grid-template-columns: minmax(0, 1fr) max-content;
      align-items: center;
      grid-gap: 16px 24px;

      & .applicant-detail-info {
        grid-row: 1;
        grid-column: 1;
        & > div {
          margin-bottom: 8px;
        }
        & .flexi-tag {
          margin: 4px;
        }
      }
      & .applicant-detail-photo {
        grid-row: 1;
        grid-column: 2;
        align-self: end;
        & .applicant-detail-photo-container {
          display: inline-block;
          padding: 0;
          border: 3px solid #fff;
          border-radius: 16px;
          background: #fff;
          box-shadow: 0 12px 28px rgba(61, 43, 86, 0.14);
          overflow: hidden;
          & img {
            display: block;
            width: 128px;
            height: 160px;
            object-fit: cover;
            border-radius: 0;
          }
        }
      }
    }
    & .application-detail-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .application-detail {
      background: #f7f8fa;
      grid-row: 3;
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }

    & .show-on-mini {
      display: none;
    }
  }

  & .sideControl {
    position: absolute;
    right: 100%;
    padding: 8px;
    border: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
    background: #fff;
    border-top: none;
    border-right: 0;
    box-shadow: -5px 0 35px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 0 ${(props) => props.theme.SecondaryRadius};
    z-index: 5;

    @media (max-width: 1000px) {
      top: 0;
      right: 0;
      display: flex;

      & .applicant-resizer {
        display: none;
      }
    }
  }
  @media (min-width: 1000px) {
    ${(props) =>
      props.maximized &&
      css`
        max-width: 100vw;

        & .side-container {
          grid-template-columns: minmax(0, 340px) minmax(0, 1fr);
          grid-template-rows: max-content auto;
          overflow: hidden;
          background: ${(props) => props.theme.PrimaryFade};

          & .applicant-info {
            grid-column: 1;
            grid-row: 1;
            position: relative;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
            min-width: 0;
            overflow: visible;

            & .applicant-info-details {
              min-width: 0;
            }

            & .applicant-info-actions {
              width: 100%;
              min-width: 0;

              &.flex-div {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 8px;

                & > * {
                  display: flex !important;
                  flex-direction: column;
                  align-items: stretch;
                  gap: 8px;
                  width: 100% !important;
                  min-width: 0;
                  max-width: 100%;
                  margin: 0 !important;
                  text-align: left;
                }

                & > * > div,
                .flexi-dropdown-trigger {
                  display: block !important;
                  width: 100% !important;
                }

                .flexi-button {
                  display: flex !important;
                  align-items: center;
                  justify-content: center;
                  width: 100% !important;
                  max-width: 100%;
                  height: 42px !important;
                  box-sizing: border-box;
                }
              }
            }
          }
          & .applicant-info-loader {
            grid-column: 1;
            grid-row: 1 /4;
            grid-template-columns: max-content;
            position: relative;
            background: #fff;
            align-items: stretch;
          }
          & .applicant-detail {
            grid-column: 1;
            grid-row: 2 / 3;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: max-content auto;
            padding-top: 0;

            & .applicant-detail-info {
              grid-row: 2;
              grid-column: 1;
            }
            & .applicant-detail-photo {
              grid-row: 1;
              grid-column: 1;

              & .applicant-detail-photo-container {
                & img {
                  width: 120px;
                  height: 150px;
                }
              }
            }
          }
          & .application-detail {
            grid-column: 2;
            grid-row: 1 / 4;
            height: 100vh;
            min-width: 0;
            overflow-y: auto;
            background: #f7f8fa;
            container-type: inline-size;

            .form-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }

            @container (max-width: 520px) {
              .form-grid {
                grid-template-columns: minmax(0, 1fr) !important;
              }
            }
          }

          & .show-on-mini {
            display: block;
          }
        }
      `}
  }
  & .applicant-info,
  & .applicant-detail {
    background: #f6f5fb;
  }

  & .applicant-detail {
    min-height: 0;
    padding-top: 0;
  }

  & .profile-identity .profile-name {
    letter-spacing: -0.02em;
    color: ${(props) => props.theme.PrimaryDark};
  }

  & .profile-number {
    color: ${(props) => props.theme.PrimaryGrey};
    font-size: 13px;
  }

  & .profile-facts {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 22px;
    margin-top: 16px;
  }

  & .profile-fact {
    min-width: 0;
    max-width: 100%;
  }

  & .profile-fact-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${(props) => props.theme.PrimaryGrey};
  }

  & .profile-fact-value {
    display: block;
    margin-top: 3px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;
    color: ${(props) => props.theme.PrimaryDark};

    a {
      color: ${(props) => props.theme.PrimaryColor};
      text-decoration: none;
    }
  }

  & .view-applicant-box {
    .flexi-tab-header {
      margin: 0 0 18px;
      gap: 4px;
      border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
      overflow-x: auto;
      flex-wrap: nowrap;
    }

    .flexi-tab-header-box {
      min-height: 48px;
      padding: 0 18px;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: -0.01em;
      color: ${(props) => props.theme.PrimaryDark};

      i {
        font-size: 16px;
      }

      &.flexi-tab-inactive {
        color: ${(props) => props.theme.PrimaryGrey};
        opacity: 1;
      }

      &.flexi-tab-label-active {
        color: ${(props) => props.theme.PrimaryColor};
        font-weight: 700;

        &::after {
          height: 3px;
          background: ${(props) => props.theme.PrimaryColor};
        }
      }
    }
  }

  & .applicant-infox {
    max-width: 960px;
    border: none;
    background: transparent;
    margin: 4px 0 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;

    & .applicant-infox-row {
      padding: 18px 18px 16px;
      background: #fff;
      border: 1px solid #eceaf3;
      border-radius: 16px;
      box-shadow: 0 8px 24px rgba(61, 43, 86, 0.04);
      display: flex;
      flex-direction: column;
      gap: 10px;

      & .applicant-infox-row-header {
        margin: 0 0 4px;
        padding: 0 0 0 12px;
        border: none;
        border-left: 3px solid ${(props) => props.theme.PrimaryColor};
        font-size: 13px !important;
        letter-spacing: 0.08em;
        color: ${(props) => props.theme.PrimaryDark};
      }

      & .form-grid {
        margin: 0;
        width: 100%;
        align-items: stretch !important;
        grid-gap: 10px !important;
        row-gap: 10px !important;
        column-gap: 10px !important;
      }

      & .single-form {
        height: 100%;
        min-width: 0;
        box-sizing: border-box;
        margin: 0;
        padding: 12px 14px;
        border: none;
        border-radius: 12px;
        background: #f6f5fb;
      }

      & .profile-field-label {
        font-size: 10px !important;
        font-weight: 600 !important;
        letter-spacing: 0.08em;
        line-height: 1.35;
        overflow-wrap: break-word;
        color: #8a849b !important;
      }

      & .profile-field-value,
      & .profile-field-value p {
        margin: 6px 0 0;
        font-size: 15px !important;
        line-height: 1.4;
        color: ${(props) => props.theme.PrimaryDark};
        font-weight: 600;
        white-space: normal !important;
        overflow-wrap: anywhere;
      }

      & .profile-field-value.is-empty,
      & .profile-field-value.is-empty p {
        color: #b7b3c2;
        font-weight: 500;
      }
    }
  }
`;

const WindowButtons = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 8px;
  background: ${(props) => props?.color};
  color: #fff;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.color && darken(0.2, props.color)};
  }
`;

export const SideModal = (props) => {
  const { children, onClose, max, setMax } = props;

  return (
    <SideModalWrapper {...props} maximized={max}>
      <div className="sideControl">
        <Tooltip>
          <WindowButtons color={Theme.PrimaryRed} onClick={onClose}>
            <i className="saf-cancel" />
          </WindowButtons>
          <Tooltiptext>Close Window</Tooltiptext>
        </Tooltip>
        <Tooltip className="applicant-resizer">
          <WindowButtons color={Theme.PrimaryGreen} onClick={() => setMax()}>
            <i className="saf-resize-full" />
          </WindowButtons>
          <Tooltiptext>{max ? 'Minimize View' : 'Maximize View'}</Tooltiptext>
        </Tooltip>
      </div>
      {children}
    </SideModalWrapper>
  );
};

SideModal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any,
  max: PropTypes.bool,
  setMax: PropTypes.func,
};

export const SideModalFullScreen = (props) => {
  const { children } = props;

  return (
    <FullScreenSideModalWrapper {...props} maximized={true}>
      {children}
    </FullScreenSideModalWrapper>
  );
};

SideModalFullScreen.propTypes = {
  children: PropTypes.any,
  max: PropTypes.bool,
};
